import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[pageListColumn]',
    standalone: false
})
export class PageListColumnDirective<T> {
  @Input() name: string;

  @Input() field: string;

  @Input() type: string;

  @Input() flex: number;

  @Input() width: number;

  @Input() align: 'start' | 'center' | 'end' = 'start';

  constructor(public template: TemplateRef<T>) {}
}
